import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import type { FilterableCheckboxListItem } from '../../components/filterable-checkbox-list/use-filterable-checkbox-list';

export const EntityFilterItemLabel = ({ item }: { item: FilterableCheckboxListItem }) => (
  <div css={entityFilterItemLabelStyles}>
    {item.isArchived && <Icon name='archive-small' color='subdued' />}
    <Text color={item.isArchived ? 'subdued' : 'default'}>{item.label}</Text>
  </div>
);

const entityFilterItemLabelStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
};
